import React from 'react';
import { SiCalendly } from 'react-icons/si';

interface CalendlyIconProps {
  color?: string;
  size?: number;
  width?: number;
  height?: number;
}

const CalendlyIcon: React.FC<CalendlyIconProps> = ({ 
  color = '#006BFF', 
  size = 24,
  width,
  height 
}) => {
  const w = width ?? size;
  const h = height ?? size;
  
  return <SiCalendly aria-hidden="true" color={color} width={w} height={h} />;
};

export default CalendlyIcon;
